// src/store/slices/organization/thunks/organization/fetchOrgUsers.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { OrgUserDTO } from '@/types/organization.dtos';
import type { OrganizationSliceData } from '@/types/organization.types';
import { mapOrgUserDTOsToRows } from '@/store/mappers/organization';

/**
 * Returns app-typed users array:
 * OrganizationSliceData['organizationUsers']
 */
export const fetchOrgUsers = createAdminAsyncThunk<
  OrganizationSliceData['organizationUsers'],
  undefined,
  { rejectValue: string }
>('organization/fetchUsers', async(_, { extra: { organizationService }, rejectWithValue }) => {
  try {
    const dtos: OrgUserDTO[] = await organizationService.getUsers();
    return mapOrgUserDTOsToRows(dtos); // map in thunk
  } catch (err: unknown) {
    const msg =
      err instanceof Error ? err.message : 'Failed to load organization users';
    return rejectWithValue(msg);
  }
});
